import React from 'react';
import { X } from 'lucide-react';

interface ErrorPopupProps {
  errorMessage: string | null;
  onClose: () => void;
}

export const ErrorPopup: React.FC<ErrorPopupProps> = ({ errorMessage, onClose }) => {
  if (!errorMessage) return null;

  return (
    <div className="error-popup-container">
      <div className="error-popup-box">
        <X className="error-popup-icon" onClick={onClose} style={{ cursor: 'pointer' }} />
        <span className="error-popup-text">{errorMessage}</span>
      </div>
    </div>
  );
};
